export enum SmartformsTenant {
  DHL = 'dhl',
}
